import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import {
  Card,
  Table,
  Stack,
  Paper,
  Button,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  IconButton,
  TableContainer,
  TableHead,
  CircularProgress,
  Box,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import Iconify from "../components/iconify";
import Scrollbar from "../components/scrollbar";
import { useNavigate } from "react-router-dom";
import { get, post } from "src/utils/networkUtils";
import StageDialog from "src/components/stage-admin/StageDialog";
import { getUserPermissions } from "src/utils/permissionsUtils";

export default function StagesPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(null);
  const [openId, setOpenId] = useState(null);
  const [rows, setRows] = useState([]);
  const [openStageDialog, setOpenStageDialog] = useState(false);
  const [stage, setStage] = useState(null);
  const [weeks, setWeeks] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState(() => {
    return localStorage.getItem("selectedStageWeek") || "";
  });
  const [weeklyLeaderboard, setWeeklyLeaderboard] = useState([]);
  const [loadingLeaderboard, setLoadingLeaderboard] = useState(false);
  const { isViewer } = getUserPermissions();
  const [loadingPromoteRelegate, setLoadingPromoteRelegate] = useState(false);
  useEffect(() => {
    get(`/admin/stageWeeks?weeksBefore=-3&weeksAfter=1`).then(function (
      response
    ) {
      setWeeks(
        response
          .map((week) => ({
            weekId: week.weekId,
            weekStart: week.weekStart,
            weekEnd: week.weekEnd,
            stages: week.stages || [],
          }))
          .sort((a, b) => new Date(b.weekStart) - new Date(a.weekStart)) || []
      );
    });

    // get(`/admin/stages`)
    //   .then(function (response) {
    //     setRows(response.stages);
    //   });
  }, []);

  useEffect(() => {
    localStorage.setItem("selectedStageWeek", selectedWeek);
    if (selectedWeek && weeks.length > 0) {
      const weekData = weeks.find((week) => week.weekId === +selectedWeek);
      if (weekData && weekData.stages) {
        setRows(weekData.stages);

        setLoadingLeaderboard(true);
        const stageIds = weekData.stages
          .map((stage) => stage.stageId)
          .join(",");
        get(`/admin/weeklyLeaderboard?stageIds=${stageIds}&type=global`)
          .then((response) => {
            setWeeklyLeaderboard(response.leaderboard || []);
            setLoadingLeaderboard(false);
          })
          .catch((error) => {
            console.error("Error fetching weekly leaderboard:", error);
            setLoadingLeaderboard(false);
          });
      } else {
        setRows([]);
        setWeeklyLeaderboard([]);
      }
    } else {
      setRows([]);
      setWeeklyLeaderboard([]);
    }
  }, [selectedWeek, weeks]);

  const handleWeekChange = (event) => {
    setSelectedWeek(event.target.value);
  };

  const handleOpenMenu = (event) => {
    setOpen(event.currentTarget);
    setOpenId(event.currentTarget.id);
  };

  const handleCloseMenu = () => {
    setOpen(null);
    setOpenId(null);
  };

  const handleCloseStageDialog = () => {
    setStage(null);
    setOpenStageDialog(false);
  };
  const handleOpenEditStageDialog = (stageId) => {
    const stage = rows.find((item) => item.stageId === stageId);
    console.log(stage, stageId);
    if (stage) {
      setStage(stage);
      setOpenStageDialog(true);
      setOpen(null);
      setOpenId(null);
    }
  };
  const handleSuccessStageDialog = () => {
    window.location.reload(true);
  };
  const promoteRelegateDivisionHandler = () => {
    setLoadingPromoteRelegate(true);
    const selectedWeekData = weeks.find(
      (week) => week.weekId === +selectedWeek
    );
    const nextWeekData = weeks.find(
      (week) => week.weekId === +selectedWeek + 1
    );
    if (selectedWeekData && nextWeekData) {
      const stageIds = selectedWeekData.stages
        .map((stage) => stage.stageId)
        .join(", ");
      const nextStageIds = nextWeekData.stages
        .map((stage) => stage.stageId)
        .join(", ");
      post(
        `/admin/stages/adjust-divisions?stageIds=${stageIds}&nextStageIds=${nextStageIds}`
      )
        .then(function (response) {})
        .finally(() => {
          setLoadingPromoteRelegate(false);
        });
    } else {
      setLoadingPromoteRelegate(false);
      //TODO show error
    }
  };
  const payPrizeHandler = () => {
    setLoading(true);
    const selectedWeekData = weeks.find(
      (week) => week.weekId === +selectedWeek
    );
    if (selectedWeekData) {
      const stageIds = selectedWeekData.stages
        .map((stage) => stage.stageId)
        .join(", ");

      post(`/admin/stages/pay-prizes?stageIds=${stageIds}`).then(function (
        response
      ) {
        window.location.reload(false);
      });
    }
  };
  const isWeeklyPrizesPaid = (selectedWeek) => {
    const weekData = weeks.find((week) => week.weekId === +selectedWeek);
    if (weekData && weekData.stages) {
      return weekData.stages.every((stage) => stage.isPrizesPaid);
    }
    return false;
  };

  return (
    <>
      <Helmet>
        <title> Stages </title>
      </Helmet>

      <Container>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Stages
          </Typography>
          <Button
            variant="contained"
            startIcon={<Iconify icon="eva:plus-outline" />}
            onClick={() => setOpenStageDialog(true)}
          >
            Create Stage
          </Button>
        </Stack>

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mb={3}>
          <FormControl fullWidth>
            <InputLabel id="week-select-label">Select Week</InputLabel>
            <Select
              labelId="week-select-label"
              id="week-select"
              value={selectedWeek}
              label="Select Week"
              onChange={handleWeekChange}
            >
              {weeks.map((week) => (
                <MenuItem key={week.weekId} value={week.weekId}>
                  {`${new Intl.DateTimeFormat("en-US", {
                    month: "short",
                  }).format(new Date(week.weekStart))} ${new Date(
                    week.weekStart
                  ).getDate()} - ${new Intl.DateTimeFormat("en-US", {
                    month: "short",
                  }).format(new Date(week.weekEnd))} ${new Date(
                    week.weekEnd
                  ).getDate()}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>

        <Card>
          {rows === null || loading ? (
            <Box
              sx={{ display: "flex", justifyContent: "center" }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Scrollbar>
              <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Stage ID</TableCell>
                      <TableCell>Name</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                      <TableCell>Lobby</TableCell>
                      <TableCell>Leaderboard</TableCell>
                      <TableCell>Completed</TableCell>
                      <TableCell>Paid</TableCell>
                      <TableCell align="right"></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {row.stageId}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.name}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.startDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.endDate}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <img
                            style={{
                              margin: "0 auto",
                              width: 100,
                              background: "grey",
                            }}
                            alt="Stage"
                            src={`${process.env.REACT_APP_STORAGE_URL}/ultimatefan/contests_lobby_competition_${row.stageId}.png`}
                          />
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <img
                            style={{
                              margin: "0 auto",
                              width: 100,
                              background: "grey",
                            }}
                            alt="Stage"
                            src={`${process.env.REACT_APP_STORAGE_URL}/ultimatefan/contests_competition_${row.stageId}.png`}
                          />
                        </TableCell>

                        <TableCell component="th" scope="row">
                          {row.isCompleted ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          {row.isPrizesPaid ? (
                            <Iconify
                              icon={"eva:checkmark-circle-2-outline"}
                              sx={{ color: "green" }}
                            />
                          ) : (
                            <Iconify
                              icon={"eva:close-circle-outline"}
                              sx={{ color: "red" }}
                            />
                          )}
                        </TableCell>
                        <TableCell align="right">
                          <IconButton
                            size="large"
                            color="inherit"
                            onClick={handleOpenMenu}
                            id={row.stageId}
                          >
                            <Iconify icon={"eva:more-vertical-fill"} />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Scrollbar>
          )}
        </Card>

        {selectedWeek && (
          <Card sx={{ mt: 4 }}>
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{ p: 2 }}
            >
              <Typography variant="h6">Weekly Leaderboard</Typography>
              <Button
                variant="contained"
                startIcon={
                  loadingPromoteRelegate ? (
                    <CircularProgress size={20} />
                  ) : (
                    <Iconify icon="eva:cloud-upload-outline" />
                  )
                }
                onClick={() => promoteRelegateDivisionHandler()}
                disabled={loadingPromoteRelegate} //TODO check if promotion/relegation already handled for the week
              >
                Promote/Relegate Division
              </Button>
              <Button
                variant="contained"
                startIcon={<Iconify icon="eva:cloud-upload-outline" />}
                onClick={() => payPrizeHandler()}
                disabled={isWeeklyPrizesPaid(selectedWeek)}
              >
                Pay Prizes
              </Button>
            </Stack>
            {loadingLeaderboard ? (
              <Box
                sx={{ display: "flex", justifyContent: "center" }}
                style={{ padding: 20 }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <Scrollbar>
                <TableContainer component={Paper}>
                  <Table
                    sx={{ minWidth: 650 }}
                    aria-label="weekly leaderboard table"
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell>Rank</TableCell>
                        <TableCell>User ID</TableCell>
                        <TableCell>Username</TableCell>
                        <TableCell>Coins</TableCell>
                        <TableCell>Custom Prize</TableCell>
                        <TableCell>Points</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {weeklyLeaderboard.map((row, index) => (
                        <TableRow
                          key={index}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell>{row.rank}</TableCell>
                          <TableCell>{row.userId}</TableCell>
                          <TableCell>
                            <a
                              href={`/dashboard/profile?user_id=${row.userId}`}
                            >
                              {row.name}
                            </a>
                          </TableCell>
                          <TableCell>{row.draftWinnings}</TableCell>
                          <TableCell>{row.draftCustomPrizeWinnings}</TableCell>
                          <TableCell>{row.score}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Scrollbar>
            )}
          </Card>
        )}
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: "top", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            p: 1,
            width: 160,
            "& .MuiMenuItem-root": {
              px: 1,
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        {!isViewer && (
          <MenuItem onClick={() => handleOpenEditStageDialog(openId)}>
            <Iconify icon={"eva:edit-outline"} sx={{ mr: 2 }} />
            Edit
          </MenuItem>
        )}

        <MenuItem
          onClick={() =>
            navigate(`/dashboard/stage/leaderboard?stage_id=${openId}`)
          }
        >
          <Iconify icon={"eva:list-outline"} sx={{ mr: 2 }} />
          Leaderboard
        </MenuItem>
      </Popover>

      {openStageDialog && (
        <StageDialog
          stage={stage}
          open={openStageDialog}
          onSuccessHandler={handleSuccessStageDialog}
          onClose={handleCloseStageDialog}
        />
      )}
    </>
  );
}
